import { render } from "./OptinForm.vue?vue&type=template&id=b07f9378"
import script from "./OptinForm.vue?vue&type=script&lang=js"
export * from "./OptinForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__